import { motion } from "framer-motion";
import { useT } from "@/i18n/LanguageContext";

export default function WhatWeDo() {
    const { t } = useT();
    const items = t.whatWeDo.items.map((it, i) => ({
        ...it,
        n: String(i + 1).padStart(2, "0"),
    }));

    return (
        <section
            id="what-we-do"
            data-testid="what-we-do-section"
            className="relative py-24 md:py-32 border-t border-[rgba(201,169,110,0.10)]"
        >
            <div className="max-w-[1280px] mx-auto px-6 md:px-12">
                <p className="text-[11px] uppercase tracking-[0.14em] text-[#C9A96E] font-medium mb-6">
                    {t.whatWeDo.label}
                </p>
                <h2 className="font-display text-[28px] md:text-[36px] font-medium leading-[1.15] tracking-[-0.02em] max-w-[820px] mb-16">
                    {t.whatWeDo.headlineLead}{" "}
                    <span className="text-[rgba(232,230,223,0.5)]">
                        {t.whatWeDo.headlineMuted}
                    </span>
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {items.map((it, i) => (
                        <motion.div
                            key={it.n}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{
                                duration: 0.6,
                                delay: i * 0.1,
                                ease: "easeOut",
                            }}
                            data-testid={`what-we-do-card-${i + 1}`}
                            className="group relative p-8 md:p-10 border border-[rgba(201,169,110,0.15)] rounded-[4px] hover:border-[rgba(201,169,110,0.35)] transition-colors"
                        >
                            <div className="text-[#C9A96E] text-[12px] tracking-[0.14em] mb-8 font-display font-medium">
                                {it.n}
                            </div>
                            <h3 className="font-display text-[22px] md:text-[24px] font-medium leading-[1.25] tracking-[-0.01em] mb-4 text-[#E8E6DF]">
                                {it.title}
                            </h3>
                            <p className="text-[15px] leading-[1.7] text-[rgba(232,230,223,0.6)]">
                                {it.body}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
